import type { SUBJECT_6W_URI } from '~/features-shared/libs/interfaces/entity'

/**
 * Extract the identifier from a subject uri
 *
 * @params subjectUri  The subject uri to extract the identifier from
 * @return The identifier
 */
export function getIdFromSubjectUri(subjectUri: undefined): undefined
export function getIdFromSubjectUri(subjectUri: SUBJECT_6W_URI): string
export function getIdFromSubjectUri(subjectUri: SUBJECT_6W_URI | undefined) {
  return (typeof subjectUri == 'string' && subjectUri.split(':')
    ?.pop()) || subjectUri
}

/**
 * Checks if the uri points to a wedo content
 *
 * @param uri - uri to check
 * @returns true - If uri points to a wedo content
 */
export function isWedoContent(uri: string) {
  return uri.startsWith('uuid:') || uri.startsWith('dsxplan:Task')
}
